export default __webpack_public_path__ + "static/media/boy.1ef3b20a.gif";